// Thirdparty
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";

// Theme
import "@styles/index.css";

import buttons from "@scripts/components/buttons";
import mobileBar from "@scripts/components/mobile-bar";
import pageOverlay from "@scripts/components/page-overlay";
import scrollReveal from "@scripts/components/scroll-reveal";
import siteAnnouncementBar from "@scripts/components/site-announcement-bar";
import siteHeader from "@scripts/components/site-header";
import siteMenu from "@scripts/components/site-menu";
import siteWidget from "@scripts/components/site-widget";
import wysiwyg from "@scripts/components/wysiwyg";

buttons.init();
mobileBar.init();
pageOverlay.init();
if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  scrollReveal.init();
}
siteAnnouncementBar.init();
siteHeader.init();
siteMenu.init();
siteWidget.init();
wysiwyg.init();

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    document.documentElement.classList.remove("_preload");
  }, 250);

  const setHeights = () => {
    const siteHeader = document.querySelector(".site-header");

    if (siteHeader) {
      document.documentElement.style.setProperty("--site-header-height", `${Math.ceil(siteHeader.offsetHeight)}px`);
    }
  };

  window.addEventListener("resize", setHeights);

  setHeights();
});

// Dynamically load any components based on page conditions

const pageHas = (selector) => {
  return document.querySelectorAll(selector).length;
};

const loadComponents = async () => {
  if (pageHas("[data-slide-toggle]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-slide-toggle" */ "@scripts/components/slide-toggle"
    );

    component.init();
  }

  if (pageHas("[data-scroll]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-scroll-to" */ "@scripts/components/scroll-to"
    );

    component.init();
  }

  if (pageHas("[data-paginated-list]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-paginated-list" */ "@scripts/components/paginated-list"
    );

    component.init();
  }

  if (pageHas("[data-tablist]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-tablist" */ "@scripts/components/tablist"
    );

    component.init();
  }

  if (pageHas("[data-popover]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-popover" */ "@scripts/components/popover"
    );

    component.init();
  }

  if (pageHas("[data-modal]")) {
    const { default: component } = await import(/* webpackChunkName: "components-modal" */ "@scripts/components/modal");

    component.init();
  }

  if (pageHas(".media-slider")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-page-header" */ "@scripts/components/media-slider"
    );

    component.init();
  }

  if (pageHas("[data-tooltip]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-tooltip" */ "@scripts/components/tooltip"
    );

    component.init();
  }

  if (pageHas("[data-two-column-form]")) {
    const { default: component } = await import(
      /* webpackChunkName: "components-two-column-form" */ "@scripts/components/two-column-form"
    );

    component.init();
  }
};

loadComponents();
